import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';
import { hexToRgba, overlayAnimation } from '../../utils/style';

interface PageOverlayProps {
	isOpen: boolean;
}

export const PageOverlay = styled('div') `
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 11;
	background: ${hexToRgba(StyleColor.Black, 80)};
	${ (props: PageOverlayProps) => overlayAnimation(props.isOpen) };
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PageOverlay/styles.ts